import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Section.scss';

const Section = ({ className = '', children }) => (
  <section className={classNames('hiw-section', className)}>{children}</section>
);

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default Section;
